import { ThemeOptions } from '@mui/material';
import { createTheme as createMuiTheme } from '@mui/material/styles';
import createMuiPalette from '@mui/material/styles/createPalette';
import { deepmerge } from '@mui/utils';

import { getMuiButton } from 'modules/themes/components/button';
import { darkPalette } from 'modules/themes/darkPalette';

import { getMuiAccordion } from './components/accordion';
import { getMuiAccordionDetails } from './components/accordionDetails';
import { getMuiAccordionSummary } from './components/accordionSummary';
import { getMuiCssBaseline } from './components/cssBaseline';
import { getMuiDialog } from './components/dialog';
import { getMuiMenu } from './components/menu';
import { getMuiOutlinedInput } from './components/outlinedInput';
import { getMuiSelect } from './components/select';
import { getMuiTextField } from './components/textField';
import { BREAKPOINTS, FONT_FAMILY, SPACING } from './const';

export function createMainTheme() {
  const baseTheme = createMuiTheme({
    palette: createMuiPalette(darkPalette),
    spacing: SPACING,
    breakpoints: {
      values: BREAKPOINTS,
    },
    typography: {
      fontFamily: FONT_FAMILY,
    },
  });

  const options: ThemeOptions = {
    components: {
      MuiCssBaseline: getMuiCssBaseline(baseTheme),
      MuiButton: getMuiButton(baseTheme),
      MuiOutlinedInput: getMuiOutlinedInput(),
      MuiMenu: getMuiMenu(),
      MuiSelect: getMuiSelect(baseTheme),
      MuiDialog: getMuiDialog(baseTheme),
      MuiAccordion: getMuiAccordion(),
      MuiAccordionDetails: getMuiAccordionDetails(baseTheme),
      MuiAccordionSummary: getMuiAccordionSummary(baseTheme),
      MuiTextField: getMuiTextField(),
    },
  };

  return createMuiTheme(deepmerge(baseTheme, options));
}

export const mainTheme = createMainTheme();
